import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface ResGetMeasureHistory {
  success: boolean;
  message: string;
  result: [
    {
      MEASURE_ID: string,
      MEASURE_NAME: string,
      MEASURE_DONE: number,
      LAST_DONE: Date
    }
  ];
}

interface ResGetResearchHistory {
  success: boolean;
  message: string;
  result: [
    {
      RESEARCH_ID: string,
      RESEARCH_NAME: string,
    }
  ];
}

interface ResGetPaymentHistory {
  success: boolean;
  message: string;
  result: {
    wait_pay: [
      {
        PAYMENT_ID: string,
        PAYMENT_NAME: string,
        PAYMENT_DATE: Date,
        PRICE: number,
        STATUS: number,
      }
    ],
    paid: [
      {
        PAYMENT_ID: string,
        PAYMENT_NAME: string,
        PAYMENT_DATE: Date,
        PRICE: number,
        PAYMENT_TYPE: {
          TYPE: string,
          DETAIL: string
        }
      }
    ],
    cancel: [
      {
        PAYMENT_DATE: Date,
        PAYMENT_ID: string,
        PAYMENT_NAME: string,
        PAYMENT_STATUS: string,
        PRICE: number,
        REF_ID: string,
        STATUS: number,
      }
    ],
    reject: [
      {
        PAYMENT_DATE: Date,
        PAYMENT_ID: string,
        PAYMENT_NAME: string,
        PAYMENT_STATUS: string,
        PRICE: number,
        REF_ID: string,
        REMARK: string,
        STATUS: string,
      }
    ]
  }
}

interface resGetReciept {

  success: boolean;
  message: string;
  result: [
    {
      PAYMENT_ID: string,
      PAYMENT_NAME: string,
      PAYMENT_TYPE: string,
      PAYMENT_PRICE: number,
      PAYMENT_DATE: string,
      SIGNATURE_BASE64: string
      NAME: string,
      PHONENUMBER: string,
      TAX_NO: string,
      ADDRESS: string,
      SPECIALPRICE: number,
      STANDARTPRICE: number,
      SIGNATURE_NAME: string,
      SIGNATURE_JOBTITAL: string,
      RECEIPT_ID: string,
      CARD_NO:string,
      REMARK_PRICE: string,
    }
  ];
}

@Injectable({
  providedIn: 'root'
})
export class UserHistoryService {

  token: string = null;
  // role: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getMeasureHistory() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetMeasureHistory>(environment.URL + '/history/getMeasureHistory', { headers: headers })
  }

  getResearchHistory() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetResearchHistory>(environment.URL + '/history/getResearchHistory', { headers: headers })
  }

  getPaymentHistory() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetPaymentHistory>(environment.URL + '/history/getPaymentHistory', { headers: headers })
  }

  cancelPayment(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post(environment.URL + '/payment/cancelPayment', body, { headers });
  }

  getReceiptById(pid) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetReciept>(environment.URL + '/receipt/getReceiptById?PAYMENT_ID=' + pid, { headers: headers })
  }
}
